import Form from 'components/Form';
import { Box, Typography } from '@mui/material';

import { Ti18nId } from 'hooks/useI18n';
import { IFormRegister, IFormValues, IFormWatch } from 'routes/Main/type';

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  onRequired: (id: Ti18nId) => void;
  onSuccess: (message: string) => void;
}

const contents = [
  '1) 귀 의료기관에서 제시한 제반 규칙을 준수함은 물론, 치료와 퇴원 등 의사 및 간호사 (또는 직원)의 정당한 지시에 따르겠습니다.',
  '2) 환자가 의료기관의 정당한 진료지침이나 교육에 반하는 무단 외출 · 외박으로 인하여 발생하는 환자의 손해에 대한 책임은 환자에게 있습니다.',
  '3) 입원료 기타 입원기간동안 발생하는 진료비는 귀 의료기관에서 정하는 납부기한 내에 납부하겠으며, 정당한 이유없이 체납될 때에는 체권확보를 위한 법적조치에 이의가 없으며, 만일 본건 의료분쟁 등으로 인하여\n     소송을 제기할 경우 관할 법원은 민사소송법에 따릅니다.',
  '4) 입원기간 중에 환자 및 보호자가 귀 의료기관의 비용 또는 기물을 고의 또는 과실로 망실, 훼손한 때에는 이를 변상합니다.',
  '5) 입원기간 중 환자 또는 보호자 등이 소지 중인 현금 기타 귀중품은 귀 의료기관이 지참한 보관장소가 있는 경우에는 보관 장소에 보관하고, 보관 장소가 따로 없는 경우에는 귀 의료기관이 지정한 직원에게 보관을\n     의료기관은 책임이 없습니다.',
  '6) 입원기간 중 이루어진 진단, 검사, 치료 등 의료행위와 관련하여 분쟁이 생겼을 때에는 「의료사고 피해구제 및 의료분쟁 조정 등에 관한 법률」에 따라 한국의료분쟁조정중재원에 조정·중재를 신청하거나  「소비자\n    기본법」에 따라 한국소비자원에 피해구제 등을 신청 할 수 있습니다.',
];

const GuardianInfo = (props: Props) => {
  const { register, disabled } = props;
  return (
    <>
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '10px',
          }}
        >
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              whiteSpace: 'nowrap',
              lineHeight: '38px',
            }}
          >
            나는 나의
          </Typography>
          <Form.MuiTextField
            required={false}
            disabled={disabled}
            sx={{ width: '130px' }}
            placeholder="관계"
            {...register('patient_name')}
          />
          <Form.MuiTextField
            required={false}
            disabled={disabled}
            sx={{ width: '130px' }}
            placeholder="환자 성명"
            {...register('patient_name')}
          />
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              whiteSpace: 'nowrap',
              lineHeight: '38px',
            }}
          >
            질환에 대하여 검사나 치료를 요하는 줄 알지만 사정에 의하여
            퇴원합니다.
          </Typography>
        </Box>
      </Box>
      <Box sx={{ width: '98%', margin: '0px auto 24px auto' }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '10px',
          }}
        >
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
              whiteSpace: 'nowrap',
              lineHeight: '38px',
            }}
          >
            따라서 차후에 일어나는 환자의 질병에 대하여서는 서명자 자신이
            책임지겠습니다.
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default GuardianInfo;
